'use client';

import { useEffect } from 'react';
import { AiOutlineCloseCircle } from '@/components/icons';
import styled from 'styled-components';

interface ZoomBoxProps {
  dataArr?: string[];
  data?: Array<{ [key: string]: string }>;
  imageVar?: string;
  imageIndex: number;
  setImageIndex?: (index: number) => void;
  state: boolean;
  imageWidth?: string;
  imageHeight?: string;
  image?: string;
  event: (state: boolean, index: number | null) => void;
  zoom?: string;
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
`;

const ImageContainer = styled.div`
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  position: absolute;
`;

const CloseButton = styled.div`
  display: inline-block;
  margin-left: 40px;
  margin-top: -40px;
  vertical-align: top;
  cursor: pointer;

  svg {
    font-size: 26px;
    color: #fff;
  }
`;

const ZoomedImage = styled.img<{ $zoom?: string }>`
  zoom: ${(props) => props.$zoom || '2'};
  display: inline-block;
  max-width: 90vw;
  max-height: 90vh;
`;

const ZoomBox: React.FC<ZoomBoxProps> = ({
  dataArr,
  data,
  imageVar,
  imageIndex,
  state,
  image,
  event,
  zoom,
}) => {
  useEffect(() => {
    if (state) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [state]);

  if (!state) return null;

  const getImageSrc = () => {
    if (dataArr && dataArr.length > 0 && imageIndex > -1) {
      return dataArr[imageIndex];
    }
    if (data && data.length > 0) {
      return imageVar ? data[imageIndex]?.[imageVar] : data[imageIndex]?.image;
    }
    if (image) {
      return image;
    }
    return '';
  };

  const imageSrc = getImageSrc();

  return (
    <Overlay onClick={() => event(false, null)}>
      <ImageContainer onClick={(e) => e.stopPropagation()}>
        {imageSrc && <ZoomedImage src={imageSrc} alt="Zoomed view" $zoom={zoom} />}
        <CloseButton>
          <AiOutlineCloseCircle onClick={() => event(false, null)} />
        </CloseButton>
      </ImageContainer>
    </Overlay>
  );
};

export default ZoomBox;
